function dateToFormat(date: Date | string | null | undefined): string {
	if (!date) {
		return "Invalid date";
	}

	// Если дата приходит как строка, пытаемся преобразовать ее в объект Date
	if (typeof date === "string") {
		date = new Date(date);
	}

	// Проверка на валидность даты
	if (isNaN(date.getTime())) {
		return "Invalid date";
	}

	const pad = (num: number) => num.toString().padStart(2, "0");
	return `${pad(date.getDate())}.${pad(
		date.getMonth() + 1
	)}.${date.getFullYear()} в ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export default dateToFormat;
